import { useAuth } from "../context/AuthContext";
import Dashboard from "./Dashboard";
import BrandDashboard from "./brand/BrandDashboard";
import AgentDashboard from "./agency/AgentDashboard";

export default function DashboardRouter() {
  const { user } = useAuth();
  if (!user) return null;
  const t = user.account_type;
  if (t === "brand") return <BrandDashboard />;
  if (t === "agent" || t === "club") return <AgentDashboard />;
  return <Dashboard />;
}
